import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import styles from './HomePage.module.css';

const HomePage = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className={styles.container}>
      
      {/* SECTION HERO (Haut de page) */}
      <header id="hero" className={styles.hero}>
        <div className={styles.heroContent}>
          <h1 className={styles.title}>
            Pilotez votre activité de consulting <br />
            <span className={styles.highlight}>en toute simplicité</span>
          </h1>
          <p className={styles.subtitle}>
            AKM App est la solution tout-en-un pour gérer vos missions, 
            suivre vos factures et analyser vos performances financières.
          </p>
          <div className={styles.ctaGroup}>
            <Link to="/login" className={styles.ctaButton}>
              Accéder à mon espace
            </Link>
            <a href="#features" className={styles.secondaryButton}>
              Découvrir les outils
            </a>
          </div>
        </div>
        
        {/* Décoration visuelle (cercle abstrait) */}
        <div className={styles.heroShape}></div>
      </header>

      {/* SECTION FEATURES */}
      <section id="features" className={styles.featuresSection}>
        <h2 className={styles.sectionTitle}>Pourquoi choisir AKM ?</h2>
        <div className={styles.featuresGrid}>
          
          <div className={styles.featureCard}>
            <div className={styles.iconWrapper}>🚀</div>
            <h3>Gestion Centralisée</h3>
            <p>Retrouvez toutes vos missions, Partenaires et consultants au même endroit. Fini les fichiers Excel éparpillés.</p>
          </div>
          
          <div className={styles.featureCard}>
            <div className={styles.iconWrapper}>💰</div>
            <h3>Suivi Financier</h3>
            <p>Visualisez votre CA, vos frais et vos marges en temps réel grâce à des tableaux de bord interactifs.</p>
          </div>
          
          <div className={styles.featureCard}>
            <div className={styles.iconWrapper}>⚡</div>
            <h3>Automatisation</h3>
            <p>Gagnez du temps sur la gestion administrative. Générez vos reportings en quelques clics.</p>
          </div>

          <div className={styles.featureCard}>
            <div className={styles.iconWrapper}>🔒</div>
            <h3>Sécurité Maximale</h3>
            <p>Vos données sensibles et celles de vos Partenaires sont chiffrées et protégées selon les standards actuels.</p>
          </div>

        </div>
      </section>

    </div>
  );
};

export default HomePage;